'use client';

import { HeroBanner } from "@/components/frontend/common/hero-banner";

type CompanyHeroProps = {
  name: string;
  locale: string;
  contactHref: string;
  demoHref: string;
};

export function CompanyHero({ name, locale, contactHref, demoHref }: CompanyHeroProps) {
  const title = `${name}`;
  const description = `Learn about ${name}'s compensation plan, products, and business opportunity in network marketing.`;
  const pill = "MLM Company Profile";

  return (
    <>
      <HeroBanner
        title={title}
        description={description}
        pill={pill}
      />

    </>
  );
}
